export const EMAIL_INTERACTION_TYPE = 'email';

export const isEmailInteractionType = (interactionType) => interactionType === EMAIL_INTERACTION_TYPE;

export const getDurationAriaLabel = (label) => {
  const replacements = [
    [/</g, 'Less than'],
    [/>/g, 'More than'],
    [/(\d+)h/g, (match, hour) => `${hour} hour${hour === '1' ? '' : 's'}`],
    [/(\d+)m/g, (match, minute) => `${minute} minute${minute === '1' ? '' : 's'}`],
  ];

  return replacements.reduce((text, [regex, replacer]) => text.replace(regex, replacer), label);
};

export const getDurationOptionsWithAriaLabels = (durations) => durations.map((option) => ({
  ...option,
  ariaLabel: getDurationAriaLabel(option.display_name),
}));

export const buildSubmissionValues = (values = {}, allowDurationReset = false) => {
  if (!isEmailInteractionType(values?.interaction?.type)) {
    return values;
  }

  const interaction = {
    ...values.interaction,
  };

  if (allowDurationReset) {
    interaction.duration = null;
  } else {
    delete interaction.duration;
  }

  return {
    ...values,
    interaction,
  };
};

const getInteractionType = (props) => props.fields?.interaction?.type?.value;

const getDurationField = (props) => props.fields?.interaction?.duration;

export const syncDurationForInteractionType = (prevProps, props) => {
  const prevType = getInteractionType(prevProps);
  const currentType = getInteractionType(props);

  if (prevType === currentType) {
    return;
  }

  if (!isEmailInteractionType(currentType)) {
    return;
  }

  const durationField = getDurationField(props);

  if (!durationField || !durationField.onChange) {
    return;
  }

  durationField.onChange('');
};
